<template>
  <vs-popup class="formula_note_update_popup"
            id="popup"
            title="FORMULATIONS QC TEST CREATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="flash_point" name="flash_point" rules="required" v-slot="{ errors }">
                <small class="label">
                  Flash point <span v-if="q_c_quide.flash_point" class="qc-test-guide-text">(Guide: {{ q_c_quide.flash_point }})</span>
                </small>
                <vs-input type="text" v-model="form.flash_point" class="w-full"  name="flash_point" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="appearance" name="appearance" rules="required" v-slot="{ errors }">
                <small class="label">
                  Appearance <span v-if="q_c_quide.appearance_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.appearance_from }} - {{ q_c_quide.appearance_to }})</span>
                </small>
                <vs-input type="text" v-model="form.appearance" class="w-full"  name="appearance" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3" v-if="type === 'liquid'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="refractive_index" name="refractive_index" :rules="type === 'liquid' ? 'required' : ''" v-slot="{ errors }">
                <small class="label">
                  Refractive index <span v-if="q_c_quide.ri_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.ri_from }}-{{ q_c_quide.ri_to }})</span>
                </small>
                <vs-input type="text" v-model="form.refractive_index" class="w-full"  name="refractive_index" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                  @input="generateErrors()"/>
                  <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'refractive_index')">You have RI results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="specific_gravity" name="specific_gravity" :rules="type === 'liquid' ? 'required' : ''" v-slot="{ errors }">
                <small class="label">
                  Specific gravity <span v-if="q_c_quide.sg_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.sg_from }}-{{ q_c_quide.sg_to }})</span>
                </small>
                <vs-input type="text" v-model="form.specific_gravity" class="w-full"  name="specific_gravity" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                  @input="generateErrors()"/>
                  <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'specific_gravity')">You have SG results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="type === 'liquid'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="ph" name="ph" :rules="type === 'liquid' ? 'ph_value' : ''" v-slot="{ errors }">
                <small class="label">
                  pH <span v-if="q_c_quide.ph_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.ph_from }}-{{ q_c_quide.ph_to }})</span>
                </small>
                <vs-input type="text" v-model="form.ph" class="w-full"  name="ph" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                  @input="generateErrors()"/>
                  <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'ph')">You have pH results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="odour" name="odour" rules="required" v-slot="{ errors }">
                <small class="label">
                  Odour <span v-if="q_c_quide.odour" class="qc-test-guide-text">(Guide: {{ q_c_quide.odour }})</span>
                </small>
                <vs-input type="text" v-model="form.odour" class="w-full"  name="odour" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="taste" name="taste" rules="required" v-slot="{ errors }">
                <small class="label">
                  Taste <span v-if="q_c_quide.taste" class="qc-test-guide-text">(Guide: {{ q_c_quide.taste }})</span>
                </small>
                <vs-input type="text" v-model="form.taste" class="w-full"  name="taste" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="brix" name="brix" rules="" v-slot="{ errors }">
                <small class="label">
                  Brix <span v-if="q_c_quide.brix_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.brix_from }}-{{ q_c_quide.brix_to }})</span>
                </small>
                <vs-input type="text" v-model="form.brix" class="w-full"  name="brix" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                  @input="generateErrors()"/>
                <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'brix')">You have brix results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="dosage" name="dosage" rules="" v-slot="{ errors }">
                    <small class="label">Max Dosage</small>
                    <vs-input type="text" v-model="form.dosage" name="dosage" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="notes" name="notes" rules="required" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-full w-full md:mb-0">-->
<!--              <ValidationProvider vid="notes" name="notes" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Comment</small>-->
<!--                <vs-textarea class="mb-0" v-model="comment" height="150px" />-->
<!--                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="flex flex-wrap items-center justify-end">
            <vs-button :disabled="validations_errors.length > 0" @click.stop="onClickCreateQc('approve')" class="ml-auto mt-2">QC Approve</vs-button>
            <vs-button  @click.stop="onClickCreateQc('reject')" class="ml-4 mt-2" type="filled" color="danger">QC Reject</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {},
      comment: '',
      q_c_quide: {},
      validations_errors: []
    }
  }

export default {
  name: 'QcTestCreateFormulationPopUp',
  data () {
    return initialState()
  },
  props: {
    type: {type: String, default: ''}
  },
  methods:{
    async openPopup (id, qa_status_id, q_c_quide) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset()
        this.id = id
        this.qa_status_id = qa_status_id
        this.q_c_quide = q_c_quide
        this.form.formulation_id = this.id
        this.open = true
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async onClickCreateQc (status) {
      const vue = this;
      this.$refs.form.validate().then(async (x) => {
        if(x) {
          try {
            this.$vs.loading();
            await FormulationsRepository.createFormulaQcTest(this.form)
            if(status === 'approve' && this.qa_status_id !==4) {
              await FormulationsRepository.qaApproveFormulations(this.id, { comment: 'QA Approved'})
            }
            if(status === 'reject' && this.qa_status_id !== 3) {
              await FormulationsRepository.qaRejectFormulations(this.id, { comment: 'QA Rejected'})
            }
            this.showSuccessMessage('Formulation qc test created');
            await vue.$parent.refreshData()
            this.open = false
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close();
        }
      })
    },
    generateErrors() {
        this.validations_errors = [];
        
        const fieldRanges = {
          specific_gravity: ['sg_from', 'sg_to'],
          ph: ['ph_from', 'ph_to'],
          refractive_index: ['ri_from', 'ri_to'],
          brix: ['brix_from', 'brix_to']
        };

        for (const field of Object.keys(fieldRanges)) {
          const [fromKey, toKey] = fieldRanges[field];
          if (this.q_c_quide[fromKey] && this.q_c_quide[toKey] && this.form[field]) {
            const fieldValue = Number(this.form[field]);
            if (fieldValue < Number(this.q_c_quide[fromKey]) || fieldValue > Number(this.q_c_quide[toKey])) {
              this.validations_errors.push({ field, error: true });
            }
          }
        }
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .formula_note_update_popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
  .qc-test-guide-text {
    color: coral;
    font-weight: bold ;
    margin-left: 5px;
  }
</style>
